import { render, staticRenderFns } from "./GroupRulesEdit.vue?vue&type=template&id=7c8fcab6&"
import script from "./GroupRulesEdit.vue?vue&type=script&lang=js&"
export * from "./GroupRulesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports